import { render, staticRenderFns } from "./NewDesignJob.vue?vue&type=template&id=a24ca154&"
import script from "./NewDesignJob.vue?vue&type=script&lang=js&"
export * from "./NewDesignJob.vue?vue&type=script&lang=js&"
import style0 from "./NewDesignJob.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ATextblock: require('/app/components/ATextblock.vue').default,AApplyForm: require('/app/components/AApplyForm.vue').default})
